import * as React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

function Sidebar(props) {
  const { archives, description, social, title, link } = props;
  return (
    <Grid item xs={12} md={4}>
      {/* <Paper elevation={0} sx={{ p: 2, bgcolor: 'grey.200', border: "1px solid black"}} >
        <Typography variant="h6" gutterBottom >
         Top list depends on the highest Views and Comments
        </Typography>
        
      </Paper> */}
      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Top 10
      </Typography>
      { archives?.length > 0 && archives?.map((x, xds) => (
        <CardActionArea key={xds} component="a" href={x.link}>
        <Card sx={{ display: 'flex' }}>
          <CardContent sx={{ flex: 1 }}>
            <Typography component="h2" variant="h5">
            #{xds + 1} - {x.title}
            </Typography>
            {/* <Typography variant="subtitle1" color="text.secondary">
              {post.date}
            </Typography> */}
            <Typography variant="subtitle1" paragraph dangerouslySetInnerHTML={{
                        __html: x.description
                }} />
          </CardContent>
        </Card>
      </CardActionArea>
      ))}

      {/* <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Social
      </Typography>
      {social.map((network) => (
        <Link
          display="block"
          variant="body1"
          href="#"
          key={network.name}
          sx={{ mb: 0.5 }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <network.icon />
            <span>{network.name}</span>
          </Stack>
        </Link>
      ))} */}
    </Grid>
  );
}

// Sidebar.propTypes = {
//   archives: PropTypes.arrayOf(
//     PropTypes.shape({
//       title: PropTypes.string.isRequired,
//     }),
//   ).isRequired,
//   description: PropTypes.string.isRequired,
//   social: PropTypes.arrayOf(
//     PropTypes.shape({
//       icon: PropTypes.elementType.isRequired,
//       name: PropTypes.string.isRequired,
//     }),
//   ).isRequired,
//   title: PropTypes.string.isRequired,
// };

export default Sidebar;
